import React, { Fragment } from 'react'
import { Heading } from '@myxplor/ui'
import { momentFromDate, dayFormat, weekStartFormatted } from '../../week'
import { FormDate, FormDisplayErrors } from '@myxplor/forms'

import { fileNameWithDate } from '../../io/download-csv'
import { validateCCSStartDateToToday } from './helpers'
import ReportForm from '../views/form'

const apiEndPoint = ({ gov_id, record_type }) =>
  process.env.REACT_APP_API_HOST + `/api/${record_type}/${gov_id}/reports/ccs-notifications`

// Note that this report breaks the standard pattern by implementing it's own <CCSWeekInput> component
// in order to overwrite the description to specify a 90 day period rather than a weekly period.

const onSubmit = ({ gov_id, record_type }) => ({ remote_request }) => payload =>
  remote_request.submit({
    url: `${apiEndPoint({ gov_id, record_type })}?reporting_start_date=${
      payload.reporting_start_date
    }`,
    method: 'GET',
    fileName: fileNameWithDate('CCS Notifications Report'),
  })

export const CCSNotificationsFormDateInput = ({
  reportName,
  name = 'reporting_start_date',
  value,
  errors,
  onChange,
  valid,
}) => (
  <div className="reportForm--dateRange">
    <FormDate
      name={name}
      label="Report Starting date"
      value={value}
      errors={errors}
      onChange={onChange}
      required
      today
    />

    <div className="reportForm--noHintPadding">
      {valid ? (
        <Fragment>
          This will generate a{' '}
          <abbr title="CSV files can be opened in any spreadsheet program">CSV</abbr> report of your{' '}
          {reportName} from {weekStartFormatted(value, true)}, going forward{' '}
          <strong>90 days</strong>.
        </Fragment>
      ) : (
        <FormDisplayErrors
          errors={`You can only create a ${reportName} report from the 2nd July 2018 until now.`}
        />
      )}
    </div>
  </div>
)

const FormFields = ({ values, errors, onChange, valid }) => (
  <fieldset>
    <Heading small>CCS Notifications Report</Heading>
    <CCSNotificationsFormDateInput
      reportName="CCS Notifications"
      value={values.reporting_start_date}
      errors={errors.reporting_start_date}
      onChange={onChange}
      valid={valid}
    />
  </fieldset>
)

export const ReportCCSNotifications = ({ gov_id, record_type, resetCurrentReport }) => (
  <ReportForm
    formOptions={{
      validate: validateCCSStartDateToToday,
      defaultValues: {
        reporting_start_date: dayFormat(momentFromDate()),
      },
    }}
    name="CCS Notifications Report"
    fieldsComponent={FormFields}
    resetCurrentReport={resetCurrentReport}
    onSubmit={onSubmit({ gov_id, record_type })}
  />
)



// WEBPACK FOOTER //
// ./src/reports/reports/ccs-notifications.jsx